
import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'component/utils/Modal'
import Close from 'images/close.svg'

const PricebannerErrorModal = ({
  text,
  onConfirm,
  onClose,
  title,
  above,
  okButton,
  details,
  translate
}) => (
  <Modal size='sm' className={`mission-block-container-modal ${above ? 'modal-above' : ''}`}>
    <div className='pictogram-error-modal'>
      <img src={Close} alt="erro" />

      <p className='mission-modal-title-error' style={{ fontSize: '24px', color: '#B42A27', fontWeight: '700' }}>
        {title}
      </p>

      <p className='mission-modal-text' style={{ fontSize: '18px', color: '#3C3738', marginTop: '-1px' }}>
        {text}
      </p>

      <p style={{ fontWeight: '400', fontSize: '14px', fontStyle: 'italic', color: '#3C3738' }}>
        {details}
      </p>

      <div className="custom-modal-footer" style={{ marginTop: '24px' }}>
        <button
          className="custom-modal-close-button"
          onClick={onClose}
          style={{
            fontWeight: '600',
            color: '#3C3738',
            padding: '8px 16px',
            width: "60%"
          }}
        >
          {(translate('close_button_label'))}
        </button>

        <button
          className="custom-modal-confirm-button"
          onClick={onConfirm}
        >
          {okButton}
        </button>
      </div>
    </div>
  </Modal>
);

PricebannerErrorModal.propTypes = {
  text: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  okButton: PropTypes.string.isRequired,
  above: PropTypes.bool,
  details: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
}
export default PricebannerErrorModal
